import type { FC } from 'react'
import React from 'react'
import cx from 'clsx'

interface LabelProps {
  value?: string | number
  classNames?: string
}

const Label: FC<LabelProps> = ({ value, classNames }) => {
  return value ? (
    <div
      title={String(value)}
      className={cx(
        'py-0.5 text-center h-6 flex w-fit max-w-full px-3 items-center justify-center rounded-lg border',
        classNames,
      )}
    >
      <span className="block min-w-0 truncate">{value}</span>
    </div>
  ) : null
}

export default Label
